import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import moment from "moment";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  name: string;
  designation: string;
  image: File | null;
  linkedinUrl: string;
};

const AddAdviser = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<FormData>();
  const [value, setValue] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string>("");

  useEffect(() => {
    if (data) {
      reset({
        name: data.name,
        designation: data.designation,
        linkedinUrl: data.linkedinUrl || "",
      });
    } else {
      reset({});
      setValue("");
    }
  }, [show]);

  const onSubmit = (request: FormData) => {
        if (fileError) {
      toast.error(fileError);
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("designation", request.designation);
    formData.append("linkedinUrl", request.linkedinUrl);
    if (file) {
      formData.append("image", file);
    }
    if (data?._id) {
      WebService.fileUploadPutAPI({
        action: `advisers/editAdviser/${data._id}`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.fileUploadAPI({
        action: `advisers/addAdviser`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };
  const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/svg+xml",
];
  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          setFile(null);
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {data ? "Edit Advisor" : "Add Advisor"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-2" controlId="eventImage">
              <Form.Label className="label">Image <span className="text-danger">*</span></Form.Label>
                 <div className="text-primary mt-1" style={{ fontSize: "13px" }}>
                Note: Please upload an image of size: <strong>130 × 160 px</strong> in <strong>.png, .jpeg, .jpg or .svg</strong> format.
              </div>
              <Form.Control
                type="file"
                accept="image/*"
                className="custom-image-upload"
             
                     onChange={(e) => {
                  const input = e.target as HTMLInputElement;
                  const selectedFile = input.files?.[0];

                  if (!selectedFile) return;

                  if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                    setFileError(
                      "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image"
                    );
                    // console.log(fileError)
                    //      toast.error(fileError);
                    setFile(null);
                    input.value = ""; // reset input
                    return;
                  }

                  // ✅ valid
                  setFileError("");
                  setFile(selectedFile);
                }}
              />
             {fileError && (
                <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
                  {fileError}
                </p>
              )}
            </Form.Group>
            {(file || data?.image) && (
              <div className="mb-2 event-image">
                <img
                  src={file ? URL.createObjectURL(file) : data?.image}
                  alt="Event"
                  style={{
                    maxWidth: "100%",
                    maxHeight: 200,
                    objectFit: "contain",
                  }}
                />
              </div>
            )}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <div className="error-message">{errors.name.message}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="eventLocation">
              <Form.Label className="label">
                Designation <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter designation"
                {...register("designation", {
                  required: "Designation is required",
                })}
              />
              {errors.designation && (
                <div className="error-message">
                  {errors.designation.message}
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="linkedinUrl">
            <Form.Label className="label">
              LinkedIn URL
            </Form.Label>
            <Form.Control
              type="url"
              placeholder="https://www.linkedin.com/in/username"
              {...register("linkedinUrl", {
                pattern: {
                  value:
                    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,3})+(\/[^\s]*)?$/,
                  message: "Please enter a valid LinkedIn profile URL",
                },
              })}
            />
            {errors.linkedinUrl && (
              <div className="error-message">{errors.linkedinUrl.message}</div>
            )}
          </Form.Group>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddAdviser;
